export function normalizeWhatsappConnectionsResponse(data) {
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.connections)) return data.connections;
  if (Array.isArray(data?.sessions)) return data.sessions;
  if (Array.isArray(data?.items)) return data.items;
  return [];
}

export function normalizeWhatsappConnectionStatusValue(status) {
  const value = String(status || '').trim().toLowerCase();
  if (value === 'connected' || value === 'open' || value === 'ready' || value === 'online') {
    return 'connected';
  }
  if (
    value === 'connecting' ||
    value === 'connect' ||
    value === 'pending_qr' ||
    value === 'qr_ready' ||
    value === 'awaiting_qr' ||
    value === 'qr' ||
    value === 'qr_code' ||
    value === 'pairing' ||
    value === 'pairing_code'
  ) {
    return 'connecting';
  }
  return 'disconnected';
}

function isConfiguredWhatsappConnection(connection) {
  return Boolean(
    connection?.is_configured ??
      connection?.isConfigured ??
      connection?.configured
  );
}

export function isActiveWhatsappConnection(connection) {
  const rawStatus = String(connection?.status || '').trim();
  const status = normalizeWhatsappConnectionStatusValue(connection?.status);
  return isConfiguredWhatsappConnection(connection) && (
    status === 'connected' ||
    (!rawStatus && (connection?.is_connected === true || connection?.isConnected === true))
  );
}

export function filterActiveWhatsappConnections(connections) {
  return normalizeWhatsappConnectionsResponse(connections).filter(isActiveWhatsappConnection);
}

export function isConnectingWhatsappConnection(connection) {
  return isConfiguredWhatsappConnection(connection) && normalizeWhatsappConnectionStatusValue(connection?.status) === 'connecting';
}

export function filterVisibleWhatsappConnections(connections) {
  return normalizeWhatsappConnectionsResponse(connections).filter(
    (connection) => isActiveWhatsappConnection(connection) || isConnectingWhatsappConnection(connection)
  );
}
